export const RENDER_READINESS_CHANNELS = [
    'camera',
    'postEffects',
    'reflection',
    'shadow',
    'texture',
    'transmission',
] as const

export type RenderReadinessChannel = (
    typeof RENDER_READINESS_CHANNELS[number]
)

export type RenderReadinessRevisions = Record<
    RenderReadinessChannel,
    number
>

export interface RenderShadowDiagnostics {
    bakeTimeMs?: number
    cacheKey?: string
    cacheSize: number
    cacheStatus?: 'hit' | 'miss'
}

export interface RenderReadinessSnapshot {
    error?: string
    expectedRevisions: RenderReadinessRevisions
    modelReady: boolean
    requestListenerReady: boolean
    revisions: RenderReadinessRevisions
    shadow: RenderShadowDiagnostics
}

/**
 * Browser boundary shared by the viewer and Puppeteer. Scene components only
 * report lifecycle state through this interface; they do not know how that
 * state is exposed to an external renderer.
 */
export interface RenderReadinessBridge {
    acknowledge: (
        channel: RenderReadinessChannel,
        revision: number,
    ) => boolean
    clearFailure: () => void
    fail: (message: string) => void
    reset: (
        channel: RenderReadinessChannel,
        revision: number,
    ) => void
    setModelReady: (ready: boolean) => void
    setRequestListenerReady: (ready: boolean) => void
    setShadowDiagnostics: (
        diagnostics: Partial<RenderShadowDiagnostics>,
    ) => void
    snapshot: () => RenderReadinessSnapshot
}

declare global {
    interface Window {
        modelViewerReadiness: RenderReadinessBridge
    }
}
